import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LicensesLayoutComponent } from './overview/layout/licenses-layout.component';
import { EntityPermissionGuard, AskToDeactivateGuard } from '@kpd/framework-ngx';
import { LicenseDetailsComponent } from './details/license-details.component';
import { EntityResolverTypes } from '../app.entity.resolvers';
import { titleFunction } from 'app/app-routing.module';

const licensesRoutes: Routes = [
  {
    path: 'licenses',
    component: LicensesLayoutComponent,
    data: {
      routeName: 'licenses',
      routePermissionPrefix: 'License',
      breadCrumbData: { titleFunc: titleFunction('Licenses') },
    },
    canActivate: [EntityPermissionGuard],
  },
  {
    path: 'licenses/details/license/:id',
    component: LicenseDetailsComponent,
    data: {
      routeName: 'licenseDetail',
      routeParentName: 'licenses',
      routePermissionPrefix: 'License',
      routePermissionPrefixTabs: { users: 'User.License' },
      routePermissionId: 'id',
      breadCrumbData: {
        titleResolverType: EntityResolverTypes.license,
        titleEntityIdKeys: 'id',
      },
      pageTitlePrefixFunc: titleFunction('License'),
    },
    canActivate: [EntityPermissionGuard],
    canDeactivate: [AskToDeactivateGuard],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(licensesRoutes)],
  exports: [RouterModule],
})
export class LicensesRoutingModule {}
